import { PAYOUTS_ROUTE } from './payoutTerminology'

const TASK_TYPE_PREFIX = 'Tasks::'

const RESOURCE_URL_MAP: Record<string, (id: string | number) => string> = {
  User: (id) => `/users/${id}`,
  TradingAccount: (id) => `/accounts/${id}`,
  Payout: (id) => `${PAYOUTS_ROUTE}#selected_id=${id}`,
  Deposit: (id) => `/deposits#selected_id=${id}`,
  Withdrawal: (id) => `/withdrawals#selected_id=${id}`,
  InternalTransfer: (id) => `/internal_transfers#selected_id=${id}`,
  BalanceTransaction: (id) => `/transactions#selected_id=${id}`,
  Task: (id) => `/tasks/${id}`,
  Coupon: (id) => `/coupons/${id}`,
  DiscountTier: (id) => `/discount_tiers#selected_id=${id}`,
}

export function getResourceUrl(
  resourceType: string | null | undefined,
  resourceId: string | number | null | undefined,
): string | null {
  if (!resourceType || resourceId == null) return null

  const urlBuilder = RESOURCE_URL_MAP[resourceType]
  if (urlBuilder) return urlBuilder(resourceId)

  if (resourceType.startsWith(TASK_TYPE_PREFIX)) return `/tasks/${resourceId}`

  return null
}

const RESOURCE_LABELS: Record<string, string> = {
  TradingAccount: 'Trading account',
  DiscountTier: 'Discount tier',
  InternalTransfer: 'Internal transfer',
}

export function getResourceLabel(resourceType: string, resourceId: string | number): string {
  if (resourceType.startsWith(TASK_TYPE_PREFIX)) return `Task ${resourceId}`

  return `${RESOURCE_LABELS[resourceType] ?? resourceType} ${resourceId}`
}
